import React from 'react';
import './RegisterSecim.css';
import Logo from '../../../assets/images/logo-buyuk.png';

const RegisterSecim = ({ setSelectedOption }) => {
    return (
        <section className="register-secim-section">
            <div className='secim-logo-alani'>
                <img src={Logo} alt='Logo' />
            </div>
            <div className='secim-buton-alani'>
                <button onClick={() => setSelectedOption("afazili")}>Afazili ya da Afazili Yakını</button>
                <button onClick={() => setSelectedOption("doktor")}>Doktor / Terapist</button>
            </div>
        </section>
    );
};

export default RegisterSecim;
